/**
 * Keuzelijst met tijdzones (IANA). 07-10-2026 (Jordy): Amsterdam en Manila
 * bovenaan, daarna alle zones van de browser. Gebruikt op Mass Messages →
 * Create en bij de voorkeur in Edit user / Edit chatter.
 */
import { useMemo } from 'react'
import { alleZones } from '../lib/tijdzone'

export function ZoneKeuze({ value, onChange, leegLabel, ariaLabel = 'Time zone', disabled = false }: {
  value: string
  onChange: (zone: string) => void
  /** Met een lege keuze (bv. "Default (Amsterdam)"); zonder: altijd een zone. */
  leegLabel?: string
  ariaLabel?: string
  disabled?: boolean
}) {
  const zones = useMemo(() => alleZones(), [])
  const opties = value && !zones.includes(value) ? [value, ...zones] : zones
  return (
    <select className="inp" aria-label={ariaLabel} value={value} disabled={disabled}
            data-testid="zone-keuze" onChange={(e) => onChange(e.target.value)}>
      {leegLabel !== undefined ? <option value="">{leegLabel}</option> : null}
      {opties.map((z) => <option key={z} value={z}>{z}</option>)}
    </select>
  )
}
